import React from "react";

/**
 * Capexara Process Industry brand lockup (text-only replacement).
 *
 * The legacy `formigen-*.svg` files are ignored — we render a clean
 * two-line lockup so the brand can be updated without new artwork.
 */
export default function Brand({
  height = 52,
  withTagline = true,   // kept for API compat
  testId = "brand",
}) {
  const nameSize = Math.round(height * 0.5);
  const subSize = Math.round(height * 0.22);
  return (
    <div
      data-testid={testId}
      style={{
        display: "inline-flex",
        flexDirection: "column",
        justifyContent: "center",
        lineHeight: 1.0,
        height,
        flex: "none",
      }}
    >
      <span
        style={{
          fontSize: nameSize,
          fontWeight: 900,
          letterSpacing: "-0.02em",
          color: "var(--pf-text, #fff)",
        }}
      >
        capexara<span style={{ color: "var(--pf-accent, #F26B1F)" }}>.</span>
      </span>
      {withTagline && (
        <span
          style={{
            fontSize: subSize,
            marginTop: Math.round(height * 0.06),
            fontWeight: 600,
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            color: "var(--pf-text-muted, #9CA3AF)",
          }}
        >
          Process Industry · AI Simulation
        </span>
      )}
    </div>
  );
}

export function BrandFull({ height = 160, testId = "brand-full" }) {
  return <Brand height={height} withTagline testId={testId} />;
}
